export default __webpack_public_path__ + "static/media/green_icon_with_notes.8ac0ba45.png";